import { ChangeDetectionStrategy, Component, input, InputSignal } from "@angular/core";

@Component({
  selector: "app-spinner",
  templateUrl: "./spinner.component.html",
  styleUrl: "./spinner.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpinnerComponent {
  public readonly diameter: InputSignal<number> = input<number>(75);
}
